import React, { useContext } from 'react';
import {
  OsmosisAppLinkContextDto,
  RelatedContentDto,
  VideoRelatedContentPropsDto,
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { AppContext } from '../app/AppProvider.component';
import { IframeEvent, osmosisVideoUrl } from '../../pages/ai-chat/ai-chat.constants';
import { ELSButtonIconPosition } from '../../models/button.models';
import IconWithText from '../icon-with-text/IconWithText.component';
import { isEmbeddedInIframe } from '../app/app.config';

export type RelatedContentVideoPanelProps = {
  relatedContent: RelatedContentDto;
};

const RelatedContentVideoPanel = (props: RelatedContentVideoPanelProps): JSX.Element => {
  const { appState } = useContext(AppContext);
  const videoId = props.relatedContent.contentId;
  const contentProps = props.relatedContent.contentProps as VideoRelatedContentPropsDto;
  const context = appState.appLinkData?.outPostBody?.context as OsmosisAppLinkContextDto;
  const includeIframeVideoLink = context?.includeIframeVideoLink;

  const handleLearnPageClick = () => {
    // Standalone, window.parent is this same window, so a postMessage would land
    // back here with no listener. There is no host to delegate navigation to.
    if (!isEmbeddedInIframe()) {
      window.open(contentProps.learnUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    window.parent.postMessage({
      type: IframeEvent.OSMOSIS_AI_LEARN_PAGE_CLICK,
      learnUrl: contentProps.learnUrl,
    }, '*');
  };

  const showTitleLink = includeIframeVideoLink && contentProps?.learnUrl;

  return (
    <div>
      {showTitleLink ? (
        <button
          type="button"
          className="u-els-debuttonize u-els-anchorize u-els-margin-bottom"
          onClick={handleLearnPageClick}
        >
          <IconWithText iconName="new-window" iconPrefix="hmds" iconPosition={ELSButtonIconPosition.RIGHT}>
            <h4>
              {props.relatedContent.title}
            </h4>
          </IconWithText>
        </button>
      ) : (
        <h4 className="u-els-margin-bottom">
          {props.relatedContent.title}
        </h4>
      )}
      <iframe
        title="osmosis-related-video-iframe"
        src={`${osmosisVideoUrl}/embed/${encodeURIComponent(videoId)}?auth=${appState.osmosisTokenDto.authToken}`}
        className="c-els-ai-chat__osmosis-iframe"
        allowFullScreen
      />
    </div>
  );
};

export default RelatedContentVideoPanel;
